import { observer } from "mobx-react";
import React from "react";
import {
    Legend,
    BarChart,
    CartesianGrid,
    XAxis, YAxis, Tooltip, Bar, Cell
} from "recharts";
import adminStore from "../../stores/adminStore";

@observer
class ScoreByCompetence extends React.Component {
  render() {
    const { dashboard } = adminStore;
    if (!dashboard.scores_by_competences) {
      return <div></div>;
    }
    const data = dashboard.scores_by_competences.data
    if (!data || data.length === 0) return null;
    const colors = [ "#eeaa7b", "#66b9bf", "#c09f80", "#df744a", "#94618e", "#b56357"]
    const width = window.innerWidth - 240 - 200
    const height = 300

            /*<Bar dataKey="score" fill={colors[0]} />*/
    return (
        <BarChart width={width} height={height} data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
			<Bar dataKey="score">
				{ data.map((entry, index) => ( <Cell key={`cell-${index}`} fill={colors[index % 6]} />)) }
			</Bar>
        </BarChart>
    );
  }
}

export { ScoreByCompetence };
